module.exports = __webpack_public_path__ + "img/sup_withdraw_bank3.a7cd068e.jpg";